export const SYSTEMSETTING_SEGMENTS = {
  navigation: 'navigation',
  valuedriver: 'valuedriver',
  visualizationwidget: 'visualizationwidget',
  multiSectionModule: 'multiSection',
  insights: 'guidingprinciple',
  whitelist: 'accesscontrols',
  userGuide: 'userGuide',
  systemModule: 'systemModule',
  aiConfig: 'aiConfig',
};

export const SYSTEMSETTING_SEGMENTS_MENU = [
  {
    path: `/${SYSTEMSETTING_SEGMENTS.systemModule}`,
    icon: 'grid-view',
    label: 'Project Instance',
  },
  // {
  //   path: `/${SYSTEMSETTING_SEGMENTS.navigation}`,
  //   icon: 'navigation',
  //   label: 'Navigation Tiles',
  // },
  {
    path: `/${SYSTEMSETTING_SEGMENTS.visualizationwidget}`,
    icon: 'digital-transformation',
    label: 'Visualization Widget',
  },
  // {
  //   path: `/${SYSTEMSETTING_SEGMENTS.insights}`,
  //   icon: 'guidingprinciple',
  //   label: 'Guiding Principles',
  // },
  {
    path: `/${SYSTEMSETTING_SEGMENTS.whitelist}`,
    icon: 'audience',
    label: 'Manage White List',
  },
  {
    path: `/${SYSTEMSETTING_SEGMENTS.userGuide}`,
    icon: 'audience',
    label: 'User Guide',
  },
  {
    path: `/${SYSTEMSETTING_SEGMENTS.aiConfig}`,
    icon: 'edit',
    label: 'AI Agents',
  },
];

export const SYSTEMSETTING_TITLES = {
  // [SYSTEMSETTING_SEGMENTS.navigation]: 'Manage Navigation Tiles Template',
  [SYSTEMSETTING_SEGMENTS.valuedriver]: 'Value Drivers Template',
  [SYSTEMSETTING_SEGMENTS.visualizationwidget]: 'Manage Visualization Widget',
  // [SYSTEMSETTING_SEGMENTS.insights]: 'Guiding Principles Template',
  [SYSTEMSETTING_SEGMENTS.whitelist]: 'Manage White List',
  [SYSTEMSETTING_SEGMENTS.userGuide]: 'User Guide Setting',
  [SYSTEMSETTING_SEGMENTS.systemModule]: 'Project Instance Settings',
  [SYSTEMSETTING_SEGMENTS.aiConfig]: 'AI Agent Management',
  default: 'System Settings',
};

export const SYSTEM_SETTING_PAGE_CLASSNAME = {
  [SYSTEMSETTING_SEGMENTS.insights]: 'page-guiding-principle',
};
